import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const LicenseModal = ({ show, onHide, selectedSite, rosterData }) => {
    const getLicenceConditions = () => {
        if (!rosterData || rosterData.length === 0) {
            return "<p>No licence conditions found for this site.</p>";
        }

        const uniqueLicensingConditions = [...new Set(rosterData.map(item => item.licensingConditions))];

        if (uniqueLicensingConditions.length > 0 && uniqueLicensingConditions[0]) {
            return uniqueLicensingConditions[0];
        }

        return "<p>No licence conditions found for this site.</p>";
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Licence Conditions for {selectedSite}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: getLicenceConditions() }} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LicenseModal;
